<template>
  <div class="nav-header__container">
    <div class="nav-header">
      <img :src="logoImg" alt="logo" class="nav-header__logo"/>
      <div class="nav-header__steps">
        <span class="nav-header__steps__indicator"> {{index}} </span>
        <span class="nav-header__steps__label">
          <span class="parentRoute bold" v-if="parentRoute">
            {{$t(`route.${parentRoute}`)}}
          </span>
          <font-awesome-icon
            v-if="childRoute !== '' && parentRoute !== 'validate'"
            :icon="['fal','chevron-right']"
            class="arrow selector-left-arrow"
            size="xs" />
          <span class="childRoute"
            v-if="childRoute && parentRoute !== 'validate'">
            {{ $t(`route.${childRoute}`) }}
          </span>
        </span>
      </div>
      <img :src="saveImg"
           v-show="childRoute !== 'done' && enableSaveAndQuit"
           alt="save and quite"
           class="nav-header__save"
           @click="displaySaveAndQuit = true"
      />
    </div>
    <el-progress :percentage="progress"
                 :show-text="false"
                 :stroke-width="4"
    ></el-progress>
    <save-and-quit-modal :visible.sync="displaySaveAndQuit"/>
  </div>
</template>

<script>
import logo from '@/assets/img/logo.png';
import save from '@/assets/img/icon_save.png';
import RouteManager from '../../routes/RouteManager';
import SaveAndQuitModal from '@/components/advice/modals/SaveAndQuitModal.vue';

export default {
  name: 'NavHeader',
  components: { SaveAndQuitModal },
  data() {
    return {
      displaySaveAndQuit: false,
      enableSaveAndQuit: false,
    };
  },
  computed: {
    parentRoute() {
      return this.$store.getters['routeStore/parentRoute'];
    },
    childRoute() {
      return this.$store.getters['routeStore/childRoute'];
    },
    logoImg() {
      return logo;
    },
    saveImg() {
      return save;
    },
    index() {
      switch (this.parentRoute) {
        case 'loading':
          return 1;
        case 'delivery':
          return 2;
        case 'serviceOffer':
          return 3;
        case 'furniture':
          return 4;
        default:
          return 5;
      }
    },
    progress() {
      return (RouteManager.getCurrentRouteIndex(this.$route.path)
        / (RouteManager.getNbRoute() - 1)) * 100;
    },
  },
};
</script>

<style scoped lang="scss">
  .parentRoute{
    padding-right: 3px;
  }
  .childRoute{
    font-weight: 600;
    padding-left: 3px;
  }
  .arrow{
    text-align: center;
  }
  .nav-header {
    display: grid;
    flex-grow: 1;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    font-size: 15px;
    margin-top: 4px;
    margin-bottom: 4px;

    &__container {
      height: 52px;
      display: flex;
      flex-direction: column;
    }

    &__logo {
      justify-self: start;
      padding: 0 6px;
      margin-right: 6px;
      border-right: 1px solid $--color-secondary;
    }

    &__steps {
      justify-self: start;
      display: grid;
      grid-template-columns: auto auto;
      justify-content: center;
      align-items: center;
      &__indicator {
        color: white;
        display: grid;
        margin-right: 6px;
        width: 24px;
        height: 24px;
        align-items: center;
        font-weight: bold;
        border-radius: $--border-radius-circle;
        place-content: center;
        text-align: center;
        background-color: $--color-primary;
      }
      &__label{
        color: $--color-text-primary;
        font-size: 15px;
        place-self: center;
      }
    }

    &__save {
      justify-self: end;
      padding: 0 5px;
      cursor: pointer;
    }
  }

  ::v-deep {
    .el-progress-bar {
      &__outer, &__inner {
        border-radius: 0 100px 100px 0;
      }
    }
  }
</style>
